import {FC, useState} from "react";
import langData from "../../../languages.json";
import {IconDownArrow, IconUpArrow} from "../icons/icons";
import i18n from "i18next";
import Cookie from "js-cookie";
import {getTLD} from "../../env/env";
import {Button, Dropdown} from "@wakelet/ui-kit";
import {gaLanguageChanged} from "../../analytics/ga";

export const updateLang = (countryCode: string) => {
  if (!i18n) {
    console.error("unable to translate, i18n is undefined");
    return
  }
  gaLanguageChanged(countryCode);
  if (window) {
    window.dispatchEvent(new CustomEvent("language-changed", {detail: countryCode}))
  }
  return i18n.changeLanguage(countryCode).then(() => {
    const tld = getTLD();
    Cookie.set("language", countryCode, {domain: tld});
  });
}

const defaultLang = "en-US"
export const getCurrentLang = (): string => {
  return Cookie.get("language") || defaultLang;
};

type LangType = {
  code: string
  english_name: string
  local_name: string
  locale: string,
  region: string
  is_base_language: boolean
}

type Props = {
  countryCode?: string
  updateLang: (countryCode: string) => void
}

export const LanguageSelector: FC<Props> = ({countryCode = defaultLang, updateLang}) => {
  const [showOptions, setShowOptions] = useState<boolean>(false);
  let lang = langMap[countryCode]
  if (!lang) {
    lang = langMap[defaultLang]
  }
  const icon = showOptions ? <IconDownArrow className="scale-75"/> : <IconUpArrow className="scale-75" />
  const selectLang = (countryCode: string) => {
    setShowOptions(false);
    updateLang(countryCode)
  }
  const trigger = <Button variant="secondary" data-id="language-selector">
    <Button.Label text={lang.local_name} icon={icon}/>
  </Button>;
  return <Dropdown trigger={trigger} onOpen={() => setShowOptions(true)} onClose={() => setShowOptions(false)}>
      <div data-testid="lang-selector">
        {languages.map((lang, index) => {
          return <Dropdown.Item key={index} onSelect={() => selectLang(lang.code)}>
            {lang.local_name}
          </Dropdown.Item>
        })}
      </div>
    </Dropdown>
};

const languages = langData.published as LangType[];

const toMap = () => {
  const langMap: { [key: string]: LangType } = {};
  languages.forEach(l => {
    langMap[l.code] = l
  });
  return langMap;
}

const langMap = toMap();
